import { Component, Output, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject } from 'rxjs';
import 'rxjs/Rx';
import { currentcartdetail } from '../../../models/dashboard/cart/mywallet.currentcart.Modal';
import { CardDetails, SendMoneyDetail, SendMoneySteps, StoreDetails } from '../../../models/sendmoney/sendmoney';
import { enumEventype, UserProfileTMNIovation } from '../../../models/user/user.tm.profile.model';
import { geolocation } from '../../../sharedcomponents/commonservice/geolocation/geoloc';
import { ValidateTMService } from '../../../sharedcomponents/commonservice/TmValidation/tmvalidation.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { AppSettings, enumStatusCodeList, PaymentType } from '../../../sharedcomponents/_common/constants/app.constants';
import { AlertPopupComponent } from '../../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { ErrorPopupComponent } from '../../../sharedcomponents/_directive/error-popup/error-popup.component';
import { InfoPopupComponent } from '../../../sharedcomponents/_directive/info-popup/info-popup.component';
import { CartServiceService } from '../../../_services/dashboardservice/cart/cart-service.service';
import { mywalletcard } from '../../../_services/mywallet/card/mywallet.card.service';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
import { PayagainFailedorderService } from '../../../_services/transaction/payagain-failedorder.service';
import { PayagainorderService } from '../../../_services/transaction/payagain-repaydorder.service';
import { AuthService } from '../../../_services/userservice/auth.service';
import { usercommonattribute } from '../../../_services/userservice/user.common.service';
import { AddcardComponent } from '../../card/addcard/addcard.component';
import { UserStateService } from '../../../_services/userservice/userstateservice';

import { ThreatMetrixService } from '../../../_services/ThreatMetrix/threatmetrix'

@Component({
  selector: 'app-cardlist',
  templateUrl: './cardlist.component.html',
  styleUrls: ['./cardlist.component.css'],
  providers: [mywalletcard, CartServiceService, AuthService, PayagainorderService, geolocation, ValidateTMService, ThreatMetrixService]
})
export class CardlistComponent {
  private subProfile = new Subject<boolean>();
  @Output()
  subProfileObservable = this.subProfile.asObservable();
  isCardHeaderVisible = false;
  activePath: string = '';
  PageFlow: any = {};
  dispalycardlist: any = [];
  sendMoneyDetail: SendMoneyDetail;
  currentcart: currentcartdetail;
  cardActionFrom = 0;
  cardFundingID = 0;
  fundingID = '0';
  unsubDocReq: any;
  DocumentRequired: {};
  cardNotfound = '';
  isCardAddVisble = true;
  private subDocReq = new Subject<boolean>();
  isFirstLoad: boolean = true;
  fraudDetectionPromise: Promise<any>;
  @Output()
  observableDocReq = this.subDocReq.asObservable();
  cardMessage = '';
  userProfileTMNIovation: UserProfileTMNIovation;
  enableBackButton;
  mobileScreen = false;
  private sub: any;
  constructor(
    public modal: Modal,
    private cardservice: mywalletcard,
    private router: Router,
    private route: ActivatedRoute,
    private sendMoneyService: SendMoneyService,
    private cartservice: CartServiceService,
    public utilityServ: utilityService,
    public payagainservice: PayagainFailedorderService,
    public repayagainservice: PayagainorderService,
    private translate: TranslateService,
    private geoloc: geolocation,
    private tmValidateService: ValidateTMService,
    private vcRef: ViewContainerRef,
    private auth: AuthService,
    private userStateService: UserStateService,
    public usermodel: usercommonattribute, //For getting user detail from profile
    private threatMetrixService: ThreatMetrixService
  ) { }

  ngOnInit() {
    //console.log(this.router.url);
    this.threatMetrixService.Init();
    this.activePath = this.router.url.split('/')[1];
    if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH) && this.activePath == 'mywalletcardlist') {
      this.mobileScreen = true;
    } else {
      this.mobileScreen = false;
    }

    //if ((this.activePath == 'mywallet' || this.activePath == 'mywalletcardlist') && this.usermodel.IsBeingLinked == 'true') {
    if (this.activePath == 'mywallet' || this.activePath == 'mywalletcardlist') {
      this.isCardHeaderVisible = true;
    }
    if (this.activePath == 'debitcard' || this.activePath == 'sendmoney' || this.activePath == 'repeatorder') {
      // Card Header
      this.sendMoneyService.getPageFlow().subscribe(data => {
        this.PageFlow = data;
      });
      this.currentcart = new currentcartdetail();
      this.sendMoneyDetail = new SendMoneyDetail();
      this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
        this.sendMoneyDetail = data;
      });
      this.sendMoneyService.getcurrentcartDetailData().subscribe(data => {
        this.currentcart = data;
        this.fundingID = this.currentcart.FundingId;
      });

      if (this.sendMoneyDetail.pickupTypeDetails.countryName == undefined || this.sendMoneyDetail.pickupTypeDetails.countryName == '') {
        this.router.navigate(['/dashboard']);
        return;
      }
      this.cardActionFrom = 1;
    } else if (this.activePath == 'transdebitcard') {
      this.cardActionFrom = 2;
    }
    if (this.usermodel.IsBeingLinked == 'true') {
      this.getcardlist();
    }

    if (this.usermodel.IsBeingLinked == 'false') {
      const modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblOops');
      modalData.Message = this.translate.instant('IncompleteProfilePopup_desc');

      // this.modal.open(ErrorPopupComponent, overlayConfigFactory({modalData}, BSModalContext));
      this.isCardAddVisble = false;
      this.cardNotfound = '';
      //  this.cardMessage = this.translate.instant('userNotLink__Validation');
    } else {
      this.cardNotfound = this.translate.instant('DebitCard_lblAddCardInstruction');
    }
  }

  OpenAddCard() {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    // return this.modal.open(AddcardComponent, overlayConfigFactory({ name: '' }, BSModalContext));
    const modalData: any = {};
    const _self = this;
    return this.modal.open(AddcardComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next === 'yes') {
          _self.ngOnInit();
        }
      });
    });
  }
  getcardlist() {
    this.dispalycardlist = new Array<CardDetails>();
    this.modal.overlay.defaultViewContainer = this.vcRef;
    this.utilityServ.busy = this.cardservice.getcardlistservice(this.fundingID).subscribe(data => {
      this.isFirstLoad = false;
      if (data.Envelope.Body.GetFundingResponse.StatusCode == 20001) {
        return false;
      }
      if (data.Envelope.Body.GetFundingResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        if (data.Envelope.Body.GetFundingResponse.Fundings.Funding != undefined) {
          const cardList = this.utilityServ.getArray(data.Envelope.Body.GetFundingResponse.Fundings.Funding);
          //console.log(cardList.length);
          cardList.forEach(element => {
            const crdDetail: CardDetails = new CardDetails();
            crdDetail.cardFundingID = this.utilityServ.getObjectText(element.FundingId);
            crdDetail.cardNickname = this.utilityServ.getObjectText(element.FriendlyName);
            crdDetail.cardlastfournum = this.utilityServ.getObjectText(element.AccountNumber);
            crdDetail.cardNumber = this.utilityServ.getObjectText(element.AccountNumber);
            this.utilityServ.getObjectText(element.CardTypeImage);
            // crdDetail.cardimageurl = AppSettings.imagefolder + ICE_DebitCard[this.utilityServ.getObjectText(element.SubType)] + '.png';
            crdDetail.cardimageurl = AppSettings.baseContentURL + this.utilityServ.getObjectText(element.CardTypeImage);

            this.dispalycardlist.push(crdDetail);
          });
          if (this.fundingID != '' && this.cardActionFrom == 1) {
            this.isCardAddVisble = false;
          }
        }
      } else {
        this.translate.use(sessionStorage.langCode).subscribe(res => {
          let modalData: any = {};
          modalData.Title = this.translate.instant('Common_lblOops');
          modalData.Message = data.Envelope.Body.GetFundingResponse.StatusMessage;
          this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
        });
      }
    });
  }

  payClick(obj) {

    // if(this.activePath == 'debitcard'){
    //   return;
    // }
    if (this.cardActionFrom === 1) {
      const cardDetails: CardDetails = new CardDetails();
      cardDetails.cardNickname = obj.cardNickname;
      cardDetails.cardimageurl = obj.cardimageurl;
      cardDetails.cardNumber = obj.cardlastfournum;
      cardDetails.cardlastfournum = obj.cardlastfournum;
      this.sendMoneyDetail.paymentDetails.fundingId = obj.cardFundingID;
      this.sendMoneyDetail.cardDetails = cardDetails;

      this.sendMoneyDetail.paymentDetails.paymentType = PaymentType.DebitCard;

      const storeDetails: StoreDetails = new StoreDetails();
      this.sendMoneyDetail.storeDetails = storeDetails;

      this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
      if (this.PageFlow.Value == 'repeatorder') {
        this.router.navigate(['/repeatorderlist']);
        return;
      } else {
        this.sendMoneyService.setModalPopup(SendMoneySteps.Summary);
        this.router.navigate(['/sendmoney']);
        return;
      }
    } else if (this.cardActionFrom === 2) {
      // Code for Payment from transcation history
      this.cardFundingID = obj.cardFundingID;
      this.geoGraphicalCheck();
    }
  }

  continueClick() {
    this.router.navigate(['/dashboard']);
  }
  finalMethod() {
    //alert('Final Method');
  }
  onError(exp) {
    alert(Error + exp);
  }

  geoGraphicalCheck() {
    this.utilityServ.busy = this.geoloc.islocPermissionable().subscribe(data => {
      if (data == undefined) {
        return;
      }
      if (data == true) {
        this.RePaymentTransaction();
      } else {
        this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('Message_areaPermissibleError'));
      }
    });
  }


  RePaymentTransaction() {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    let payrepayTransaction: any = {};
    const _self = this;
    const subpayagainservice = this.payagainservice.getrepaytransbenifcaryDetailData().subscribe(data => {
      payrepayTransaction = data;
      if (subpayagainservice != undefined) {
        subpayagainservice.unsubscribe();
      }
    });

    this.userProfileTMNIovation = new UserProfileTMNIovation();
    this.userProfileTMNIovation.userProfile = this.usermodel;
    this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey = sessionStorage.iovationBBKey;
    this.userProfileTMNIovation.eventType = enumEventype[enumEventype.RePayment];
    this.userProfileTMNIovation.transactionId = payrepayTransaction.orderList[0];

    if (!_self.fraudDetectionPromise) {

      _self.fraudDetectionPromise = new Promise((resolve, reject) => {

        _self.threatMetrixService.Profile().then(sessionId => {

          _self.userProfileTMNIovation.deviceProfile.SessionID = sessionId;

          _self.utilityServ.busy = _self.auth.profileTMnIovation(_self.userProfileTMNIovation).subscribe(data => {

            if (data.Envelope.Body.FraudDetectionResponse.StatusCode == 10000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
        });
      });
   }

   this.fraudDetectionPromise.then(data => {
    _self.utilityServ.busy = _self.repayagainservice.payrepayTransactionservice(payrepayTransaction, _self.cardFundingID).subscribe(
      rePaymentdata => {
        if (rePaymentdata.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.TokenInvalidOrExpired) {
          return false;
        }
        if (rePaymentdata.Envelope.Body.PaymentResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          // Navigate to
          const modalData: any = {};

          _self.modal.overlay.defaultViewContainer = _self.vcRef;
          modalData.Title = _self.translate.instant('Common_lblInfo').toString();
          modalData.Action = _self.translate.instant('Common_lblContinue').toString();
          modalData.Message = _self.translate.instant('RepaymentSuccessPopup_desc').toString();
          //  _self.modal.overlay.defaultViewContainer = _self.vcRef;
          return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              _self.router.navigate(['/transactionuserlistrepay']);
            });
          });
        }
      },
      err => {
        _self.onError(err);
      },
      () => {
        _self.finalMethod();
      }
    );
   }, errorData => {
    _self.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
   });
  }
  errorPopup(title, message) {
    let modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  deleteCard(cardInfo) {
    const modalData: any = {};
    const _self = this;
    modalData.Title = this.translate.instant('Common_lblConfirm').toString();
    modalData.Message = this.translate.instant('DebitCard_lblDeleteDesc').toString();
    modalData.Action = this.translate.instant('Common_lblContinue').toString();
    this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next == 'yes') {
          const modalData: any = {};
          modalData.Title = _self.translate.instant('Common_lblInfo').toString();
          modalData.Action = _self.translate.instant('Common_lblOk').toString();

          _self.utilityServ.busy = _self.cardservice.deleteCardservice(_self.utilityServ.getObjectText(cardInfo.cardFundingID)).subscribe(
            data => {
              if (data.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
                modalData.Message = _self.translate.instant('Message_DeleteCardMessage').toString();
              } else if (data.Envelope.Body.ResponseBase.StatusCode == '10041') {
                modalData.Message = data.Envelope.Body.ResponseBase.StatusMessage;
              } else {
                modalData.Message = _self.translate.instant('Message_errorMessage').toString();
              }
              return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                obj.onDestroy.subscribe(data => {
                  _self.ngOnInit();
                });
              });
            },
            error => {
              //console.log('Something went wrong,Unable to delte cart Item');
              this.closePopup();
            }
          );
        } else {
          // _self.closePopup();
        }
      });
    });
  }
  ValidateMobileScreen(screen) {
    // this.mobileScreen = screen.mobileScreen;
    this.enableBackButton = 'true';
    // if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
    //   this.mobileScreen = true;
    // }else{
    //   this.mobileScreen = false;
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/mywallet/card/cardlist/cardlist.component.ts